'use strict';

var ajax = require('../../ajax'),
	giftcard = require('../../giftcard'),
	util = require('../../util'),
	wallet = require('../wallet'),
	linchpin = require('int_googletagmanager/linchpin/billing'),
	linchpinCheckout = require('int_googletagmanager/linchpin/checkoutInfo'),
	billingAddressHelper = require('../../billingaddresshelper');

const $formSA = $('#secure-acceptance-form');
const isSAEmbedded = $formSA.data('embedded');
var secureAcceptance = require('int_cybersource/secureacceptance');
var secureAcceptanceEmbedded = null;
if (isSAEmbedded) {
	secureAcceptanceEmbedded = require('int_cybersource/secureacceptanceembedded');
}

/**
 * @function
 * @description Fills the Credit Card form with the passed data-parameter and clears the former cvn input
 * @param {Object} data The Credit Card data (holder, type, masked number, expiration month/year)
 */
function setCCFields(data) {
	var $creditCard = $('[data-method="CREDIT_CARD"]');
	$creditCard.find('input[name$="creditCard_owner"]').val(data.holder).trigger('change');
	$creditCard.find('input[name$="_type"]').val(data.type).trigger('change');
	$creditCard.find('input[name$="_month"]').val(data.expirationMonth).trigger('change');
	$creditCard.find('input[name$="_year"]').val(data.expirationYear).trigger('change');
	$creditCard.find('input[name$="creditCard_isSubscription"]').val(data.isSubscription).trigger('change');
	$creditCard.find('input[name$="creditCard_cardNumberWithFirst2"]').val(data.cardNumberWithFirst2).trigger('change');
	$creditCard.find('input[name$="creditCard_maskedFourDigit"]').val(data.maskedFourDigit).trigger('change');
	if (data.maskedFourDigit) {
		$creditCard.find('input[name$="_number"]').attr('maxlength', 19).parent().parent().hide();
		$creditCard.find('input[name$="_number"]').val(data.maskedNumber).trigger('change');
		$creditCard.find('input[name$="creditCard_maskedFourDigit"]').parent().parent().show();
	} else {
		$creditCard.find('input[name$="_number"]').attr('maxlength', 19).parent().parent().show();
		$creditCard.find('input[name$="_number"]').val('').trigger('change');
		$creditCard.find('input[name$="creditCard_maskedFourDigit"]').parent().parent().hide();
		$creditCard.find('input[name$="_cvn"]').val('').trigger('change').addClass('required').show();
	}
	if (data.isSubscription === true) {
		$creditCard.find('input[name$="_cvn"]').val('').trigger('change').removeClass('required').hide();
	} else {
		$creditCard.find('input[name$="_cvn"]').addClass('required').show();
	}
}

/**
 * @function
 * @description Updates the credit card form with the attributes of a given card
 * @param {String} cardID the credit card ID of a given card
 */
function populateCreditCardForm(cardID, callback) {
	// load card details
	var url = util.appendParamToURL(Urls.billingSelectCC, 'creditCardUUID', cardID);
	ajax.getJson({
		url: url,
		callback: function (data) {
			if (!data) {
				window.alert(Resources.CC_LOAD_ERROR);
				return false;
			}
			setCCFields(data);
			if (callback) {
				callback();
			}
		}
	});
}

/**
 * @function
 * @description Changes the payment method form depending on the passed paymentMethodID
 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
 */
function updatePaymentMethod(paymentMethodID) { // eslint-disable-line no-unused-vars
	var $paymentTabs = $('#payment-tabs');
	var $targetTab = $paymentTabs.find('.checkout-tabs-nav li[data-method="' + paymentMethodID + '"]');
	var targetTabIndex = 0;
	if ($targetTab.length > 0) {
		targetTabIndex = $targetTab.index();
	}
	$paymentTabs.tabs('option', 'active', targetTabIndex);
}
/**
 * @function
 * @description the main method to toggle sections on billing page
 */
function toggleBillingSection () { // eslint-disable-line no-unused-vars
	$('#main').on('click', '.checkout-right .inputs-group-title', function (e) {
		// find selected saved credit card
		e.preventDefault();
		var $selectedCCInput = $('.saved-cc-cards').find(':checked');
		var selectedCC = $selectedCCInput.val();
		// if this is event of billing address section
		if ($(this).next().hasClass('cc-billing-address-form')) {
			if ($(this).closest('.billing-section').hasClass('disable')) {
				hideBillingSection($('.pay-with-paypal'));
				cleanCreditCardForm();
			} else {
				if (selectedCC) {
					populateCreditCardForm(selectedCC);
				}
			}
		}
		// if this is event of saved credit cards section
		if ($(this).next().hasClass('saved-cc-cards')) {
			if ($(this).closest('.billing-section').hasClass('disable')) {
				if (selectedCC) {
					populateCreditCardForm(selectedCC);
				}
			} else {
				cleanCreditCardForm();
			}
		}
		// if this is event of paypal section
		if ($(this).next().hasClass('paypal')) {
			if ($(this).closest('.billing-section').hasClass('disable')) {
				hideBillingSection($('.pay-with-card'));
			}
		}
		// toggle section
		$(this).closest('.billing-section').toggleClass('disable');
		$(this).next().toggle();
	});
}

/**
 * @function
 * @description a method to hide sections on billing page
 */
function hideBillingSection ($billingSection) {
	$billingSection.addClass('disable');
	$billingSection.find('.billing-section-content').hide();
}
/**
 * @function
 * @description cleans credit card form
 */
function cleanCreditCardForm () {
	var $creditCard = $('[data-method="CREDIT_CARD"]');
	var cardData = {
			holder: '',
			type: $creditCard.find('select[name$="_type"] option:first').val(),
			maskedNumber: '',
			expirationMonth: $creditCard.find('[name$="_month"] option:first').val(),
			expirationYear: $creditCard.find('[name$="_year"] option:first').val(),
			isSubscription: false,
			maskedFourDigit: ''
	};
	setCCFields(cardData);
}
function bindPaymentMethodSelectionEvent () {
	$('.continue').on('click', function () {
		var selectedMethodId = $(this).closest('.billing-section-content').data('method');
		$('#selectedPaymentMethodID').val(selectedMethodId);
		return true;
	});
}

exports.bindPaymentMethodSelectionEvent = bindPaymentMethodSelectionEvent;

/**
 * @function
 * @description show/hide summary shipment data on billing page
 */
function toggleSummaryData () {
	if ($('.shipment-element').length > 1) {
		$('.summary-shipments-details').addClass('scrollable');
	}

	$('.shipment-element').on('click', '.plus-button, .minus-button', function () {
		var $this = $(this);
		var $shipment = $this.closest('.shipment-element');

		// Toggle the visibility of the plus and minus buttons
		$this.addClass('hidden');
		$this.siblings('.plus-button, .minus-button').removeClass('hidden');

		// Toggle the shipment address and product details
		$shipment.find('.shipment-delivery-details.collapsed').toggle();
		$shipment.find('.shipment-delivery-details.expanded').toggle();
		$shipment.find('.shipment-product-details').toggle();
	});
}

/**
 * @function
 * @description loads billing address, Gift Certificates, Coupon and Payment methods
 */
exports.init = function () {
	var $addGiftCert = $('#add-giftcert'),
		$giftCardCode = $('input[name$="_giftCertCode"]'),
		$addCoupon = $('#add-coupon'),
		// $deleteCoupon = $('.remove-coupon') placeholder if coupon has been applied and is removed from billing page
		$couponCode = $('input[name$="_couponCode"]');

	// Init event for gift card form
	giftcard.initGiftCardCheckBalance();
	// init also events handler to add gift card fields
	// and to remove PI in case if basket contains gift card PIs
	giftcard.initRemoveGCPaymentInstr();
	giftcard.initAddGiftCardFields();
	wallet.initSavedCardRemoval();

	$addCoupon.on('click', function (e) {
		e.preventDefault();
		var $error = $('.cart-coupon-code').find('.coupon-error'),
			code = $couponCode.val();
		if (code.length === 0) {
			$error.html(Resources.COUPON_CODE_MISSING);
			return;
		}

		var url = util.appendParamsToUrl(Urls.addCoupon, {couponCode: code, format: 'ajax'});
		$.getJSON(url, function (data) {
			var fail = false;
			var msg = '';
			if (!data) {
				msg = Resources.BAD_RESPONSE;
				fail = true;
			} else if (!data.success) {
				msg = data.message.split('<').join('&lt;').split('>').join('&gt;');
				fail = true;
			}
			if (fail) {
				$error.html(msg);
				return;
			}
			//if voucher has been applied successfully refresh the billing page to reflect order changes
			if (data.success) {
				window.location.assign(Urls.billing);
			}
		});
	});

	// trigger events on enter
	$couponCode.on('keydown', function (e) {
		if (e.which === 13) {
			e.preventDefault();
			$addCoupon.click();
		}
	});
	$giftCardCode.on('keydown', function (e) {
		if (e.which === 13) {
			e.preventDefault();
			$addGiftCert.click();
		}
	});
	bindPaymentMethodSelectionEvent();

	secureAcceptance.init();
	if (secureAcceptanceEmbedded) {
		secureAcceptanceEmbedded.init();
	}

	$('#payment-tabs').tabs({
		collapsible: true,
		active: false
	});

	// Open section if gift card was applied
	if ($('.gift-card-rows').length) {
		$('#payment-tabs').tabs('option', 'active', 0);
	}

	let initalBillingAddressSerialize = '';
	$('.completed-billing-address .edit-adressy').on('click', function () {
		$('.customers-address').addClass('disabled');
		$('.billing-edit-address').removeClass('disabled');
		initalBillingAddressSerialize = $formSA.serialize();
		$.uniform.update();
	});

	$('.billing-edit-address .edit-adressy').on('click', function () {
		$('.billing-edit-address').addClass('disabled');
		$('.customers-address').removeClass('disabled');
	});

	$('.billing-edit-address .save-adressy').on('click', function () {
		let updatedBillingAddressSerialize = $formSA.serialize();
		let hasChanges = updatedBillingAddressSerialize !== initalBillingAddressSerialize;
		$('.billing-edit-address').addClass('disabled');
		$('.customers-address').removeClass('disabled');
		if (!hasChanges) {
			return;
		}
		billingAddressHelper.updateCompletedBillingAddress();
		secureAcceptanceEmbedded.init({'reinit': true});
	});

	if ($('.error-message').length > 0) {
		if ($('.error-message').text().indexOf(Resources.CARD_ERROR) !== -1) {
		// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpin.paymentErrorEvent();
			}
		}
	}

	// add atttribute to mask sensitive billing info from being recorded by Contentsquare
	util.addMaskAttr('.billing-section-content .selector span');
	// GTM Linchpin analytics
	if (SitePreferences.GTM_ENABLED) {
		// track shipping info as all shipping data was already submitted at this stage of checkout
		linchpinCheckout.shippingInfoEvent();

		$('.saved-card-submit, #secure-acceptance-submit').on('click', function() {
			try {
				if (!$('input[name=paymentData]').length) {
					return;
				}

				var paymentInfo = JSON.parse($('input[name=paymentData]').val());
				paymentInfo.payment_type = 'Credit Card';

				$('input[name=paymentData]').val(JSON.stringify(paymentInfo));
				linchpinCheckout.paymentInfoEvent();
			} catch (e) {
				window.console.error(e);
			}
		});
	}

	// Display Apple Pay payment option on iOS devices
	if (window.ApplePaySession) {
		$('#payment-tabs .tab-nav-applepay').removeClass('disabled').addClass('active-session');
	}

	toggleSummaryData();

	// After 30 minutes, refresh the page
	setTimeout(function () {
		window.location.reload();
	}, 30 * 60 * 1000);
};
